class countdownTimer extends HTMLElement {
  constructor() {
    super();
    this.days = this.querySelector('.ct-units__days');
    this.days_label = this.days.nextElementSibling;
    this.hours = this.querySelector('.ct-units__hours');
    this.hours_label = this.hours.nextElementSibling;
    this.minutes = this.querySelector('.ct-units__minutes');
    this.minutes_label = this.minutes.nextElementSibling;
    this.seconds = this.querySelector('.ct-units__seconds');
    this.seconds_label = this.seconds.nextElementSibling;
    this.startDate = new Date(this.dataset.startDate).getTime();
    this.endDate = new Date(this.dataset.endDate).getTime();
    this.loop = this.dataset.loop;

    this.updateTimer();

    let timeout = this.startDate ? this.startDate - new Date().getTime() : 0;
    setTimeout(() => {
      let count_interval = setInterval(() => {
        this.updateTimer(count_interval);
      }, 1000);
    }, timeout);
  }

  updateTimer(interval) {
    let currentDate = new Date().getTime();
    let distance = this.endDate - currentDate;

    if (this.loop == 'true' && distance < 0) {
      let loopTime = this.endDate - this.startDate;
      let new_endDate = this.endDate;
      while (new_endDate <= currentDate) {
        new_endDate += loopTime;
      }
      distance = new_endDate - currentDate;
    }

    let days = Math.floor(distance / (1000 * 60 * 60 * 24));
    let days_label =
      days >= 5
        ? this.days_label.dataset.labelFiveMore
        : days <= 4 && days > 1
        ? this.days_label.dataset.labelTwoFour
        : days == 1
        ? this.days_label.dataset.labelOne
        : this.days_label.dataset.labelFiveMore;

    let hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    let hours_label =
      hours >= 5
        ? this.hours_label.dataset.labelFiveMore
        : hours <= 4 && hours > 1
        ? this.hours_label.dataset.labelTwoFour
        : hours == 1
        ? this.hours_label.dataset.labelOne
        : this.hours_label.dataset.labelFiveMore;

    let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    let minutes_label =
      minutes >= 5
        ? this.minutes_label.dataset.labelFiveMore
        : minutes <= 4 && minutes > 1
        ? this.minutes_label.dataset.labelTwoFour
        : minutes == 1
        ? this.minutes_label.dataset.labelOne
        : this.minutes_label.dataset.labelFiveMore;

    let seconds = Math.floor((distance % (1000 * 60)) / 1000);
    let seconds_label =
      seconds >= 5
        ? this.seconds_label.dataset.labelFiveMore
        : seconds <= 4 && seconds > 1
        ? this.seconds_label.dataset.labelTwoFour
        : seconds == 1
        ? this.seconds_label.dataset.labelOne
        : this.seconds_label.dataset.labelFiveMore;

    this.days.innerHTML = days;
    this.days_label.innerHTML = days_label;

    if (days == 0) {
      this.days.parentElement.classList.add('hidden');
    }

    this.hours.innerHTML = hours;
    this.hours_label.innerHTML = hours_label;

    this.minutes.innerHTML = minutes;
    this.minutes_label.innerHTML = minutes_label;

    this.seconds.innerHTML = seconds;
    this.seconds_label.innerHTML = seconds_label;

    if (distance < 0) {
      clearInterval(interval);
      this.parentElement.classList.add('hidden');
    }

    if (distance > 0) {
      this.parentElement.classList.remove('hidden');
    }
  }
}

customElements.define('countdown-timer', countdownTimer);
